var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-grey"
  }, [_c('div', {
    staticClass: "mt-3 mx-3"
  }, [_c('h4', {
    staticClass: "font-weight-lighter filter",
    on: {
      "click": _vm.toggleFilter
    }
  }, [_vm._v(" Filters "), _c('img', {
    attrs: {
      "src": "img/Filters.png",
      "alt": "filter"
    }
  })]), _c('hr')]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMobileView || _vm.filter,
      expression: "!isMobileView || filter"
    }],
    class: {
      openFilterbar: _vm.filter,
      'mobile-filter': _vm.isMobileView
    }
  }, [_vm.keywordFacet.doc_count > 0 ? _c('div', _vm._l(_vm.keywordFacet.attribute_name.buckets, function (keyword, index) {
    return _c('div', {
      key: index
    }, [keyword.key !== 'Description' && keyword.key !== 'Country' ? _c('div', [_c('h6', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: keyword.key,
        expression: "keyword.key"
      }],
      staticClass: "collapse-block-title mt-3 text-primary mx-3"
    }, [_vm._v(" " + _vm._s(keyword.key) + " "), _c('span', {
      staticClass: "tx-13"
    }, [_c('b-icon-chevron-down')], 1)]), _c('b-collapse', {
      attrs: {
        "id": keyword.key,
        "visible": "",
        "accordion": "myaccordion1",
        "role": "tabpanel"
      }
    }, [_c('div', [_c('div', _vm._l(keyword.attribute_value.buckets, function (item, index) {
      return _c('div', {
        key: index,
        staticClass: "custom-control custom-checkbox collection-filter-checkbox mx-3"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.applyFilter,
          expression: "applyFilter"
        }],
        staticClass: "custom-control-input",
        attrs: {
          "type": "checkbox",
          "id": item.key
        },
        domProps: {
          "value": item.key,
          "checked": Array.isArray(_vm.applyFilter) ? _vm._i(_vm.applyFilter, item.key) > -1 : _vm.applyFilter
        },
        on: {
          "change": [function ($event) {
            var $$a = _vm.applyFilter,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;
            if (Array.isArray($$a)) {
              var $$v = item.key,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.applyFilter = $$a.concat([$$v]));
              } else {
                $$i > -1 && (_vm.applyFilter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.applyFilter = $$c;
            }
          }, function ($event) {
            return _vm.appliedFilter(keyword.key, item.key);
          }]
        }
      }), _c('label', {
        staticClass: "custom-control-label",
        attrs: {
          "for": item.key
        }
      }, [_vm._v(_vm._s(item.key))])]);
    }), 0)])])], 1) : _vm._e()]);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "price-filter mx-3 mt-4"
  }, [_c('h6', {
    staticClass: "text-primary"
  }, [_vm._v("Price Range")]), _c('br'), _c('vue-slider', {
    attrs: {
      "min": 0,
      "max": 1500,
      "interval": 10,
      "tooltip": 'always',
      "dot-options": [{
        style: {
          backgroundColor: '#ff8a00'
        }
      }, {
        style: {
          backgroundColor: '#ff8a00'
        }
      }]
    },
    on: {
      "drag-end": _vm.updatePriceFilter
    },
    model: {
      value: _vm.priceRange,
      callback: function ($$v) {
        _vm.priceRange = $$v;
      },
      expression: "priceRange"
    }
  }), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v(" Selected Range: " + _vm._s(_vm.priceRange[0]) + " - " + _vm._s(_vm.priceRange[1]) + " ")])], 1), _vm.isMobileView ? _c('button', {
    staticClass: "close-filter-btn",
    on: {
      "click": _vm.toggleFilter
    }
  }, [_vm._v(" Close ")]) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }